<fieldset class="grid" [attr.aria-label]="'Einstellungen zu ' + aufgabenTyp()" data-test-id="aufgabe-versand-root">
	<div class="form-date-picker">
		<mat-form-field appearance="outline">
			<mat-label>Aufbewahren bis</mat-label>
			<input
				matInput
				[matDatepicker]="picker"
				[formControl]="bodyControls.aufbewahrenBis"
				data-test-id="wiedervorlage-datum" />
			<mat-datepicker-toggle matSuffix [for]="picker" />
			<mat-datepicker #picker />
			@if (bodyControls.aufbewahrenBis.errors) {
				<mat-error data-test-id="wiedervorlage-datum-error-pattern-date">
					Der Wert "Aufbewahren bis" muss ein Datum sein.
				</mat-error>
			}
		</mat-form-field>
	</div>
	<schir-int-client-notiz-in-aufgabe-editor
		class="row note"
		[aufgabenTyp]="aufgabenTyp()"
		data-test-id="aufgabe-notiz" />
</fieldset>
